import React, { useState, useEffect } from "react";
import { putEstacion as modifEstacion } from "../helpers/rutaEstaciones";
import { Modal, Button } from "react-bootstrap";
import { getLocalidades } from "../helpers/rutaLocalidades";
import { getRutas } from "../helpers/rutaRutas";
import 'animate.css';

const ModalFormEstacion = ({ estacion, handleClose, show }) => {

  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    codest: "",
    estacion: "",
    lugar: "",
  });

  useEffect(() => {
    if (estacion && estacion._id) {
      setFormValues({
        codest: estacion.codest || "",
        estacion: estacion.estacion || "",
        lugar: estacion.lugar || "",
      });
    }
  }, [estacion]);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const resp = await modifEstacion(estacion._id, formValues);
    console.log("✅ Estación actualizada:", resp);

    setShowSuccess(true); // Mostrar modal de éxito

    setTimeout(() => {
      setShowSuccess(false); // Ocultarlo
      handleClose();         // Cerrar modal principal
    }, 2000);
  } catch (error) {
    console.error("❌ Error al actualizar estación:", error);
    // Podés agregar un modal de error si querés
  }
};



  // const [localidades, setLocalidades] = useState({ data: {}, loading: true });
  // const [rutas, setRutas] = useState({ data: {}, loading: true });

  // useEffect(() => {
  //   getLocalidades().then((res) =>
  //     setLocalidades({ data: res, loading: false })
  //   );
  //   getRutas().then((res) => setRutas({ data: res, loading: false }));
  // }, []);

  return (
    <>
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Modificar Estación de Servicio</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group mt-2">
            <label>Estación</label>
            <input
              type="text"
              className="form-control"
              name="estacion"
              required
              value={formValues.estacion}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Lugar</label>
            <input
              type="text"
              className="form-control"
              name="lugar"
              required
              value={formValues.lugar}
              onChange={handleChange}
            />
          </div>

          {/* <div className="form-group mt-2">
            <label>Localidad</label>
            <select
              className="form-control"
              name="localidad"
              value={formValues.localidad}
              onChange={handleChange}
              required
            >
              <option value="">Elija una opción</option>
              {localidades.data.localidades &&
                localidades.data.localidades.map((loc) => (
                  <option key={loc._id} value={loc._id}>
                    {loc.localidad}
                  </option>
                ))}
            </select>
          </div> */}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>

    <Modal
      show={showSuccess}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="animate__animated animate__fadeInDown"
    >
      <Modal.Body className="text-center">
        <div style={{ fontSize: "3rem" }}>🖐</div>
        <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default ModalFormEstacion;
